import { createFeatureSelector, createSelector } from "@ngrx/store";
import { UserStoreState } from "../user.model";

export const selectUserState = createFeatureSelector<UserStoreState>('users');

export const selectAllUsers = createSelector(
  selectUserState,
  (state: UserStoreState) => state.users
);